import { render } from "./HeadBarLink.vue?vue&type=template&id=02531e52"
import script from "./HeadBarLink.vue?vue&type=script&lang=js"
export * from "./HeadBarLink.vue?vue&type=script&lang=js"

import exportComponent from "/builds/sites/smolke/app-kwispelcoach-com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__